// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * The id of the bundle THIS code was built from (acceptance 4, 2026-09-04).
 *
 * `scripts/deploy-frontend.py` sets `VITE_BUILD_ID` (`<git sha>-<epoch>`)
 * before `npm run build` and writes the same value as `build_id` into the
 * no-store `/aws-exports.json`, so a running tab can compare the bundle it
 * executes with the bundle currently deployed (lib/deployFreshness.ts).
 * The id also travels on every API call (`x-bb-client-build`) and in the
 * Amy invocation (`clientBuild`, logged in AMY_TURN) so a request can be
 * tied to the bundle that sent it. Locally the variable is unset → "dev";
 * the freshness check is disabled for that value (the public
 * aws-exports.json on disk may carry the LAST deploy's id).
 */
export const DEV_BUILD_ID = "dev"

export const CLIENT_BUILD_ID: string = import.meta.env.VITE_BUILD_ID || DEV_BUILD_ID

/** Request header carrying the build id on every REST call (api/client.ts). */
export const CLIENT_BUILD_HEADER = "x-bb-client-build"

/**
 * Exposes the executing build on <html data-bb-build="…"> so a live walk
 * (Playwright / a screenshot) can read which bundle a tab is running.
 */
export function exposeClientBuild(doc: Document = document): void {
  doc.documentElement.dataset.bbBuild = CLIENT_BUILD_ID
}
